import React from "react";
import Contact from "./Contact";

const App = () => {
  return (
    <div>
      <Contact />
    </div>
  );
};

export default App;
